var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"a-note-widget"},[_c('AQuillEditor',{ref:"noteEditor",staticClass:"notes",model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }